const NewsLetterPage = () => {
    return (
        <>
        <h1>This is a News Letter</h1>
        </>
    );
}

export default NewsLetterPage;